import AxiosService from './axios.service';
import { AxiosResponse } from 'axios';
import { CreateFormDto, FormPayload } from './types/types';

export class FormsService {
  static async create(dto: CreateFormDto): Promise<{ id: string; message: string }> {
    const response: AxiosResponse<{ id: string; message: string }> = await AxiosService.post('/forms', dto);
    return response.data;
  }

  static async update(id: string, dto: Partial<CreateFormDto>): Promise<FormPayload> {
    const response: AxiosResponse<FormPayload> = await AxiosService.put(`/forms/${id}`, dto);
    return response.data;
  }

  static async findAll(): Promise<FormPayload[]> {
    const response: AxiosResponse<FormPayload[]> = await AxiosService.get('/forms');
    return response.data;
  }

  static async findAllByOrg(org: string): Promise<FormPayload[]> {
    const response: AxiosResponse<FormPayload[]> = await AxiosService.get(`/forms/organization/${org}`);
    return response.data;
  }

  static async findAllByUser(rut: string): Promise<FormPayload[]> {
    const response: AxiosResponse<FormPayload[]> = await AxiosService.get(`/forms/user/${rut}`);
    return response.data;
  }


  static async findById(id: string): Promise<FormPayload> {
    const response: AxiosResponse<FormPayload> = await AxiosService.get(`/forms/${id}`);
    return response.data;
  }

  static async assignUsers(formId: string, ruts: string[]): Promise<void> {
    await AxiosService.post(`/forms/${formId}/users`, { ruts });
  }

  static async remove(id: string): Promise<void> {
    await AxiosService.delete(`/forms/${id}`);
  }
}